<template>
  <el-dialog title="设置文本" :visible.sync="show" width="80%" append-to-body>
    <el-input type="textarea" :rows="4" placeholder="请输入内容" v-model="text"></el-input>
    <div slot="footer">
      <el-button size="mini" @click="show = false">取 消</el-button>
      <el-button size="mini" type="primary" @click="doSave">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'text-iput-dialog',
  data () {
    return {
      show: false,
      text: ''
    }
  },
  methods: {
    open () {
      this.show = true
    },
    doSave () {
      this.$emit('save', this.text)
      this.show = false
    }
  }
}
</script>
